export var DialogType;
(function (DialogType) {
    DialogType["Alert"] = "alert";
    DialogType["Confirm"] = "confirm";
    DialogType["Prompt"] = "prompt";
})(DialogType || (DialogType = {}));
